import {  get,post,remove} from "@services/apiService.js";
export default {

  addFont(data,onUploadProgress, options) {
    return post(`/v4/font-manager/v1/font`, data,{ 'Content-Type': 'multipart/form-data' }, { onUploadProgress, ...options })
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        return error
      });
  },
  getFont() {
    return get(`/v4/font-manager/v1/fonts`, {})
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  deleteFont(fontID,options) {
    return remove(`/v4/font-manager/v1/font/${fontID}`, options)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      return error
    });

  }
}